import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { StandardPropertiesHyphen } from "csstype";
import { css } from "styled-components";

import { cssFromObject } from "../lib/styleUtils";

import { embeddedLinkTheme } from "./theme";
import { EmbeddedLinkProps, IEmbeddedLinkTheme } from "./types";

const makeOverriddenColorTheme = (
  theme: IEmbeddedLinkTheme,
  color: string
): IEmbeddedLinkTheme => {
  const overridePart = (themePart: StandardPropertiesHyphen) => ({
    ...themePart,
    color,
    "text-decoration-color": color,
  });

  return {
    ...theme,
    base: overridePart(theme.base),
    hover: {
      ...overridePart(theme.hover),
      filter: "brightness(0.8)",
    },
  };
};

export const EmbeddedLinkStyles = ({
  theme: styledComponentsTheme,
  color,
}: Pick<EmbeddedLinkProps, "theme" | "color">) => {
  const theme = styledComponentsTheme?.embeddedLink ?? embeddedLinkTheme;
  // If a color is provided we overide the color defined in the theme
  const overriddenTheme = isNotUndefined(color)
    ? makeOverriddenColorTheme(theme, color)
    : theme;

  return css`
    display: inline;
    width: auto;
    cursor: pointer;
    ${cssFromObject(overriddenTheme.base)}

    &:hover,
    &:focus,
    &:focus-within {
      ${cssFromObject(overriddenTheme.hover)}
    }

    &:active {
      ${cssFromObject(overriddenTheme.active)}
    }

    &:disabled {
      ${cssFromObject(overriddenTheme.disabled)}
      cursor: not-allowed;
    }
  `;
};
